import React from 'react';
import { palette } from '@livable/saas-react-components';
import { Box, Container, Typography } from '@mui/material';
import useStyles from '../../styles';
const shadowsExample = "\nimport { palette } from '@livable/saas-react-components';\n\n{ boxShadow: palette.shadows.success }";
export default function LvShadows() {
  const classes = useStyles();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h1",
    className: classes.section
  }, "Effects: Shadows"), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement("div", {
    className: classes.shadowBoxWrapper
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "shadows.light"), /*#__PURE__*/React.createElement("div", {
    className: classes.shadowBox,
    style: {
      boxShadow: palette.shadows.light
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.shadowBoxWrapper
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "shadows.mid"), /*#__PURE__*/React.createElement("div", {
    className: classes.shadowBox,
    style: {
      boxShadow: palette.shadows.mid
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.shadowBoxWrapper
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "shadows.hard"), /*#__PURE__*/React.createElement("div", {
    className: classes.shadowBox,
    style: {
      boxShadow: palette.shadows.hard
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.shadowBoxWrapper
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "shadows.header"), /*#__PURE__*/React.createElement("div", {
    className: classes.shadowBox,
    style: {
      boxShadow: palette.shadows.header
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.shadowBoxWrapper
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "shadows.success"), /*#__PURE__*/React.createElement("div", {
    className: classes.shadowBox,
    style: {
      boxShadow: palette.shadows.success
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.shadowBoxWrapper
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "shadows.info"), /*#__PURE__*/React.createElement("div", {
    className: classes.shadowBox,
    style: {
      boxShadow: palette.shadows.info
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.shadowBoxWrapper
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "shadows.warning"), /*#__PURE__*/React.createElement("div", {
    className: classes.shadowBox,
    style: {
      boxShadow: palette.shadows.warning
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.shadowBoxWrapper
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "shadows.error"), /*#__PURE__*/React.createElement("div", {
    className: classes.shadowBox,
    style: {
      boxShadow: palette.shadows.error
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.codeSnippet
  }, shadowsExample))));
}